import React, { useState } from 'react';
import styled from 'styled-components';
import { LenderActivity } from './details/LenderActivity';
import { LenderInflows } from './details/LenderInflows';
import { LenderRevenue } from './details/LenderRevenue';
import { LendersHistory } from './details/LendersHistory';

export const Tabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: 'Activity',
      content: <LenderActivity />
    },
    {
      label: 'Disbursements',
      content: <LenderInflows />
    },
    {
      label: 'Revenue',
      content: <LenderRevenue />
    },
    {
      label: 'History',
      content: <LendersHistory />
    }
  ];

  return (
    <Tab>
      <TabView>
        {tabs.map((item, index) => (
          <button
            key={index}
            className={`tab ${activeTab === index ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}>
            {item.label}
          </button>
        ))}
      </TabView>
      <TabContent>{tabs[activeTab].content}</TabContent>
    </Tab>
  );
};

const Tab = styled.div`
  width: 82%;
  padding: 0 30px;
  margin-left: 18%;
  background-color: ${({ theme }) => theme.colors.white};
`;

const TabView = styled.div`
  height: 50px;
  display: flex;
  z-index: 10;
  margin-left: -30px;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.colors?.white};
  border-bottom: 1px solid ${(props) => props.theme?.colors?.line};

  button {
    padding: 16px 32px;
    border: none;
    background-color: transparent;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    border-bottom: 2px solid transparent;

    &:hover {
      color: ${(props) => props.theme?.colors?.secondary};
    }
  }

  .active {
    color: ${(props) => props.theme?.colors?.secondary};
    border-bottom: 2px solid ${(props) => props.theme?.colors?.secondary};
  }
`;

const TabContent = styled.div`
  width: 100%;
  height: 100%;
`;
